// extracted by mini-css-extract-plugin
module.exports = {"OTPInput":"otpinput_OTPInput__cn3iV"};